import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail, MapPin } from "lucide-react";
import { LOGO_URL } from "../lib/assets";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#EDE3D4] border-t border-[#C9A227]/15 pt-24 pb-10 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(#D4AF37 1px, transparent 1px), linear-gradient(90deg, #D4AF37 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full overflow-hidden border border-[#C9A227]/40">
                <img src={LOGO_URL} alt="Tarini" className="w-full h-full object-cover scale-[1.35]" />
              </div>
              <div>
                <div className="font-bodoni text-2xl text-[#1E1A17]">Tarini</div>
                <div className="overline text-[10px]">Astro Vastu Solutions</div>
              </div>
            </div>
            <p className="text-[#6B5F55] text-sm leading-relaxed max-w-md">
              Ancient Vastu wisdom, meticulously tuned to modern homes and workplaces.
              Guiding you to align, energise, and manifest — from the heart of Mumbai.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">Navigate</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-[#1E1A17]/80 hover:text-[#A67C00]">Home</Link></li>
              <li><Link to="/vastu" className="text-[#1E1A17]/80 hover:text-[#A67C00]">Vastu Principles</Link></li>
              <li><Link to="/about" className="text-[#1E1A17]/80 hover:text-[#A67C00]">About Divya</Link></li>
              <li><Link to="/contact" className="text-[#1E1A17]/80 hover:text-[#A67C00]">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-5">Connect</div>
            <ul className="space-y-3 text-sm text-[#1E1A17]/85">
              <li className="flex items-center gap-3"><Mail size={14} className="text-[#A67C00]" /> tariniastrovastusolutions@gmail.com</li>
              <li className="flex items-center gap-3"><MapPin size={14} className="text-[#A67C00]" /> Powai, Mumbai</li>
            </ul>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" aria-label="Instagram" className="p-2 border border-[#C9A227]/30 hover:border-[#C9A227] text-[#A67C00] transition-colors"><Instagram size={16} /></a>
              <a href="#" aria-label="YouTube" className="p-2 border border-[#C9A227]/30 hover:border-[#C9A227] text-[#A67C00] transition-colors"><Youtube size={16} /></a>
            </div>
          </div>
        </div>

        <div className="relative select-none">
          <h2 className="font-bodoni text-[22vw] md:text-[17vw] leading-none tracking-tighter text-transparent text-center"
              style={{ WebkitTextStroke: "1px rgba(166,124,0,0.35)" }}>
            TARINI
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-10 border-t border-[#C9A227]/10 text-xs text-[#6B5F55]">
          <div>© {new Date().getFullYear()} Tarini Astro Vastu Solutions. All rights reserved.</div>
          <div className="tracking-[0.25em] uppercase text-[#A67C00]/80">Align · Energise · Manifest</div>
        </div>
      </div>
    </footer>
  );
}
